import { Routes } from '@angular/router';
import { roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const frameworkContractsRoutes: Routes = [
  {
    path: 'framework-contracts',
    title: 'Rahmenverträge Übersicht',
    loadComponent: () =>
      import('./framework-contracts-list/framework-contracts-list').then(
        m => m.FrameworkContractsListComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.CONTRACTS_WRITE, UserRoles.CONTRACTS_READ] },
  },
  {
    path: 'framework-contracts/new',
    title: 'Neuer Rahmenvertrag',
    loadComponent: () =>
      import('./framework-contract-form/framework-contract-form').then(
        m => m.FrameworkContractFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.CONTRACTS_WRITE, UserRoles.CONTRACTS_READ] },
  },
  {
    path: 'framework-contracts/:id/edit',
    title: 'Rahmenvertrag bearbeiten',
    loadComponent: () =>
      import('./framework-contract-form/framework-contract-form').then(
        m => m.FrameworkContractFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.CONTRACTS_WRITE, UserRoles.CONTRACTS_READ] },
  },
];
